import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, CalendarDays, Users, GitBranch, FileText, BookOpen, LogOut, Settings } from "lucide-react";

const LOGO_BLACK = "https://customer-assets.emergentagent.com/job_9bee4b07-8d72-479e-a1c0-b19de3e7f530/artifacts/13f66ozi_biro_logo_black-350x100.png";

const navItems = [
    { to: "/admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/admin/bookings", icon: BookOpen, label: "Bokningar" },
    { to: "/admin/contacts", icon: Users, label: "Kontakter" },
    { to: "/admin/pipeline", icon: GitBranch, label: "Pipeline" },
    { to: "/admin/offers", icon: FileText, label: "Offerter" },
    { to: "/admin/calendar", icon: CalendarDays, label: "Kalender" },
    { to: "/admin/settings", icon: Settings, label: "Inställningar" },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/admin/login");
    };

    return (
        <div className="flex h-screen overflow-hidden bg-[#F5F5F5]" data-testid="admin-layout">
            <aside className="w-64 bg-white border-r border-neutral-200 flex flex-col" data-testid="admin-sidebar">
                <div className="p-6 border-b border-neutral-100">
                    <img src={LOGO_BLACK} alt="Birò" className="h-5" />
                    <span className="text-[10px] uppercase tracking-[0.15em] text-neutral-400 mt-1 block">Admin</span>
                </div>
                <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto admin-scroll">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`nav-${item.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                                    isActive ? "bg-neutral-100 text-black font-medium" : "text-neutral-600 hover:bg-neutral-50 hover:text-black"
                                }`
                            }
                        >
                            <item.icon size={18} />
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-4 border-t border-neutral-100">
                    <div className="text-xs text-neutral-500 mb-2">{user?.email}</div>
                    <button
                        data-testid="admin-logout-btn"
                        onClick={handleLogout}
                        className="flex items-center gap-2 text-sm text-neutral-500 hover:text-black transition-colors"
                    >
                        <LogOut size={16} /> Logga ut
                    </button>
                </div>
            </aside>
            <main className="flex-1 overflow-y-auto admin-scroll">
                <Outlet />
            </main>
        </div>
    );
}
